import React, { useEffect, useRef } from 'react';

const ScrollingMarquee = () => {
  const marqueeContainerRef = useRef(null);
  const marqueeContentRef = useRef(null);
  const rafIdRef = useRef(null);
  const isVisibleRef = useRef(false);

  useEffect(() => {
    const marqueeContainer = marqueeContainerRef.current;
    const marqueeContent = marqueeContentRef.current;
    if (!marqueeContainer || !marqueeContent) return;

    const marqueeClone = marqueeContent.cloneNode(true);
    marqueeContainer.appendChild(marqueeClone);

    let containerWidth = marqueeContainer.offsetWidth;
    let contentWidth = marqueeContent.offsetWidth;
    let position = containerWidth;

    const animate = () => {
      if (!isVisibleRef.current || document.hidden) {
        rafIdRef.current = requestAnimationFrame(animate);
        return;
      }

      position -= 1.7;
      marqueeContent.style.transform = `translateX(${position}px)`;

      if (position <= -contentWidth) {
        position = containerWidth;
      }

      rafIdRef.current = requestAnimationFrame(animate);
    };

    // Only start animating when visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisibleRef.current = entry.isIntersecting;
      },
      { threshold: 0.05 }
    );
    observer.observe(marqueeContainer);

    rafIdRef.current = requestAnimationFrame(animate);

    return () => {
      if (rafIdRef.current) {
        cancelAnimationFrame(rafIdRef.current);
      }
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={marqueeContainerRef}
      style={{
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      <div ref={marqueeContentRef} style={{ display: 'inline-block' }} className='scrolling-text-sec'>
        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

        <span className='marquess'>
            It's time to get rentid. Start for free. Earn more than ever before. Take control of your business.
        </span>

      </div>
    </div>
  );
};

export default ScrollingMarquee;
